import apiClient from './apiClient';

export const bigqueryApi = {
  getStatus: async () => {
    const response = await apiClient.get('/bigquery/status');
    return response.data;
  },
  getLoginUrl: async () => {
    const response = await apiClient.get('/google/login-url');
    return response.data;
  },
  getProjects: async () => {
    const response = await apiClient.get('/bigquery/projects');
    return response.data;
  },
  getDatasets: async (projectId) => {
    const response = await apiClient.get(`/bigquery/projects/${projectId}/datasets`);
    return response.data;
  },
  getTables: async (projectId, datasetId) => {
    const response = await apiClient.get(`/bigquery/projects/${projectId}/datasets/${datasetId}/tables`);
    return response.data;
  },
  disconnect: async () => {
    const response = await apiClient.post('/bigquery/disconnect');
    return response.data;
  },
  setBillingProject: async (projectId) => {
    const response = await apiClient.post('/bigquery/billing-project', { project_id: projectId });
    return response.data;
  },
  listRoutines: async (projectId, datasetId) => {
    const response = await apiClient.get(`/bigquery/projects/${projectId}/datasets/${datasetId}/routines`);
    return response.data;
  }
};
